import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CityPopover = styled.div`
  width: 342px;
  position: absolute;
  top: 39px;
  left: ${props => (props.placement === 'left' ? '-1px' : 'auto')};
  right: ${props => (props.placement === 'right' ? '-1px' : 'auto')};
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.22);
  z-index: 200;
  background: var(--white);

  @media (min-width: 768px) {
    border-radius: 8px;
  }

  @media (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100vw / var(--html-zoom, 1));
    height: calc(100 * var(--full-vh));
  }

  .btn {
    font-weight: 600;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 15px;
    line-height: 1.6em;
    min-width: 119px;
    margin-right: 10px;

    @media (max-width: 767px) {
      font-size: 13px;
      padding: 10px 15px;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .btn-secondary {
    @media (min-width: 768px) {
      background: none;
    }
  }
`;

export const InnerContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 15px 24px 20px 20px;

  @media (max-width: 767px) {
    padding: 30px 30px 30px 40px;
  }

  @media (max-width: 320px) {
    padding: 30px;
  }
`;

export const Header = styled.div`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--carbone100);
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25em;
  color: var(--carbone70);
  letter-spacing: 0.02em;
  margin: 12px 0 20px;

  @media (max-width: 767px) {
    margin: 12px 0 40px;
  }

  @media (max-width: 320px) {
    br {
      display: none;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
`;

export const BtnEdit = styled(Link)`
  font-size: 14px;
  line-height: 1.25em;
  font-weight: 600;
  letter-spacing: 0.02em;

  @media (max-width: 767px) {
    font-size: 14px;
    color: var(--secondary-brand);
    transition: var(--transition);

    &:hover {
      color: var(--secondary-brand);
    }
  }
`;

export const LocImage = styled.div`
  margin-bottom: 15px;
  width: 60px;
`;

export const Triangle = styled.div`
  top: -8px;
  z-index: 111;
  width: 11px;
  padding-bottom: 2.4%;
  overflow: hidden;
  position: absolute;
  left: ${({ placement }) => (placement === 'left' ? '16px' : 'auto')};
  right: ${({ placement }) => (placement === 'right' ? '16px' : 'auto')};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    transform-origin: 0 100%;
    transform: rotate(45deg);
  }
`;
